import { defineStore } from "pinia"
import { cloneObject } from '@/utils';
import { getSupportedLocales } from "@/util/i18n/supported-locales";


export const useStrangerStore = defineStore("stranger", {
    state: () => {
        return {
            initialized: false,
            initialConfig: {},
            availableLocales: "",
            sections: [],
            details: {},  
            directory: null,   
            walkman: null,    
            talkiewalkie: null,
            envelopes: null,   
            tutorialDone: false,            
            solved: false,
        }
    },
    actions: {
        initialize(config) {
            this.availableLocales = cloneObject(config.stranger.availableLocales);
            this.sections = cloneObject(config.stranger.sections);
            this.directory = cloneObject(config.stranger.directory);
            this.walkman = cloneObject(config.stranger.walkman);
            this.talkiewalkie = cloneObject(config.stranger.talkiewalkie);   
            this.envelopes = cloneObject(config.stranger.envelopes);
            this.details = cloneObject(config.stranger.caseDetails);            
            this.initialConfig = config;
            this.initialized = true;
            this.tutorialDone = false;
            this.solved = false;
            this.loadState();
        },
        getAvailableLocales() {
            const supportedLocales = getSupportedLocales();
            return this.availableLocales.map(l => supportedLocales.find(sl => sl.code === l));
        },
        findEvidence(s) {
            const evidences = this.sections.find((v) => v.id === "evidences");
            if(!evidences) {
                console.log("Section evidences not found");
                return;
            }

            const section = evidences.subsections.find((v) => v.id === s);
            if(!section) {
                console.log(`Subsection ${s} not found`);
                return;
            }

            return section
        },        
        findEnvelope(s) {
            const envelope = this.sections.find((v) => v.id === "envelopes");
            if(!envelope) {
                console.log("Section envelope not found");
                return;
            }

            const section = envelope.subsections.find((v) => v.id === s);
            if(!section) {
                console.log(`Subsection ${s} not found`);
                return;
            }

            return section
        },        
        unlockEnvelope(e) {
            let envelope = this.findEnvelope(e);
            envelope.locked = false;
            this.saveState();
        },
        enableEnvelope(e) {
            let envelope = this.findEnvelope(e);
            envelope.disabled = false;
            this.saveState();
        },

        getEnvelope(env) {
            return this.envelopes.places.find((s) => s.env === env);
        },
        solveEnvelope(env) {
            this.getEnvelope(env).solved =true; 
            this.saveState();
        },
        enableEvidence(e) {
            let evidence = this.findEvidence(e);
            evidence.disabled = false;
            this.saveState();
        },        
        saveState() {
            let o = {
                availableLocales: this.availableLocales,
                sections: this.sections,
                directory: this.directory,
                walkman: this.walkman,
                talkiewalkie: this.talkiewalkie,
                envelopes: this.envelopes,
                tutorialDone: this.tutorialDone,
                solved: this.solved,
            }
            localStorage.setItem('strangerStorage', JSON.stringify(o));
        },
        loadState() {
            const savedState = localStorage.getItem('strangerStorage');

            if (savedState) {
                let o = JSON.parse(savedState);

                this.availableLocales = o.availableLocales;
                this.sections = o.sections;
                this.directory = o.directory;
                this.walkman = o.walkman;
                this.talkiewalkie = o.talkiewalkie;                
                this.envelopes = o.envelopes;
                this.tutorialDone = o.tutorialDone;
                this.solved = o.solved;
            } 
        },
        resetState() {
            this.availableLocales = cloneObject(this.initialConfig.stranger.availableLocales);
            this.sections = cloneObject(this.initialConfig.stranger.sections);
            this.directory = cloneObject(this.initialConfig.stranger.directory);
            this.walkman = cloneObject(this.initialConfig.stranger.walkman);
            this.talkiewalkie = cloneObject(this.initialConfig.stranger.talkiewalkie);   
            this.envelopes = cloneObject(this.initialConfig.stranger.envelopes);            
            this.tutorialDone = false;
            this.solved = false;
            this.saveState();
        },
        formatDate (inputDate, format)  {
            if (!inputDate) return '';

            const padZero = (value) => (value < 10 ? `0${value}` : `${value}`);
            const parts = {
                yyyy: inputDate.getFullYear(),
                MM: padZero(inputDate.getMonth() + 1),
                dd: padZero(inputDate.getDate()),
                HH: padZero(inputDate.getHours()),
                hh: padZero(inputDate.getHours() > 12 ? inputDate.getHours() - 12 : inputDate.getHours()),
                mm: padZero(inputDate.getMinutes()),
                ss: padZero(inputDate.getSeconds()),
                tt: inputDate.getHours() < 12 ? 'AM' : 'PM'
            };

            return format.replace(/yyyy|MM|dd|HH|hh|mm|ss|tt/g, (match) => parts[match]);
        }
    }
})
